<template>
    <div class="gradient-prof" :class="classBanner" v-if="show == 'sv'">
        <div class="text-center text-dark">
            <h5 class="fw-light mt-3 mb-0">¡Instala nuestra App!</h5>
        </div>
        <div class="text-center text-dark p-3 pb-0">    
            <p class="small lh-1">Mejora la experiencia y accede a más funcionalidades. </p>
            <button class="btn btn-secondary w-100 p-2" id="buttonInstall" @click="install()">Instalar</button>
        </div>   
        <!--Waves Container-->
        <div>
        <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
        <defs>
        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="parallax">
        <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
        <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
        <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
        <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
        </g>
        </svg>
        </div>
        <!--Waves end-->
    </div>
    <div v-if="show == 'wp'" :class="classBanner">
        <p>💡Accede a más funcionalidades instalando nuestra App desde <a class="text-link pointer" @click="install()">aquí</a>.</p>
    </div>
    <div v-if="show == 'nav'" :class="classBanner">
        <img src="@/assets/imgs/install-icon-nav.png" @click="install()" style="width:35px"/>
    </div>





    <div class="gradient-prof" :class="classBanner2" v-if="show == 'sv'">
        <div class="text-center text-dark">
            <h5 class="fw-light mt-3 mb-0">¡Activa las notificaciones!</h5>
        </div>
        <div class="text-center text-dark p-3 pb-0">    
            <p class="small lh-1">¡Actívalas ahora y lleva el control de tu actividad en tiempo real!</p>
            <router-link class="btn btn-secondary w-100 p-2" :to="{name: 'notifications',}">Más Info</router-link>
        </div>   
        <!--Waves Container-->
        <div>
        <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 24 150 28" preserveAspectRatio="none" shape-rendering="auto">
        <defs>
        <path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
        </defs>
        <g class="parallax">
        <use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
        <use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
        <use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
        <use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
        </g>
        </svg>
        </div>
        <!--Waves end-->
    </div>
    <div v-if="show == 'nav'" :class="classBanner2">
        <router-link class="" :to="{name: 'notifications',}"><img src="@/assets/imgs/install-icon-nav.png" style="width:35px"/></router-link>
        
    </div>
    
    
</template>
<script>
export default { 
    name: "installApp",
    props: ['show'],
    data(){
        return{ 
            classBanner: 'd-none',
            classBanner2: 'd-none',
            prompt: ''
        }

    },

    mounted: function () { 
        this.checkInstalled();
    },
    
    methods:{
        async checkInstalled(){
          if (window.matchMedia('(display-mode: standalone)').matches) { 
              if(!localStorage.getItem('pushNotifications')){
                this.classBanner2 = 'd-none';
              }else{
                this.classBanner2 = 'd-none';
              }
            }
            this.prompt = await prompt;
            this.classBanner = bannerpwa;
            if(!this.classBanner){    
                bannerpwa = 'd-none'; //Ocultamos el boton
                this.classBanner = bannerpwa;
            }
            if (window.matchMedia('(display-mode: standalone)').matches) { 
             
                bannerpwa='d-none'; // ocultamos el banner 
                this.classBanner = bannerpwa;
            }
        },
        install(){
            if(this.show == 'wp'){
                this.$parent.closeWa()
            }
            bannerpwa = 'd-none'; //Ocultamos el boton
            this.classBanner = bannerpwa;
            prompt.prompt(); //Indicamos a windows nos abra la notificacion de instalacion
            prompt.userChoice // Ejecutamos la promesa
                .then((choiceResult) => {
                    if (choiceResult.outcome === 'accepted') {
                        console.log('El usuario acepto el aviso de pwa');
                    } else {
                        console.log('El usuario descarto el aviso de pwa');
                        bannerpwa = 'd-block'; //Ocultamos el boton
                        this.classBanner = bannerpwa;
                    }
                    prompt = null; //Al regresar la varible a null beforeinstallprompt 
                    //vuelve a disparase y por ende el boton se hara visible
                });
        }
    },
    
}
</script>
<style scoped>
.gradient-prof{
    background: rgb(255, 255, 255);
    background: linear-gradient(180deg, rgba(255, 255, 255, 1) 15%, rgb(0 199 162) 68%, rgb(0 65 147) 100%);
    padding: 0;
    white-space: normal;
  }
  @media only screen and (min-width: 720px) {
    .gradient-prof{
        border-radius: 24px;
        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.05), 0 0 6px 0 rgba(0, 0, 0, 0.05) !important;
        overflow: hidden;
    }
  }
  
  .waves {
    position: relative;
    width: 100%;
    height: 5vh;
    margin-bottom: -27px;
    min-height: 75px;
    max-height: 150px;
  }
  /* Animation */

.parallax > use {
  animation: move-forever 25s cubic-bezier(.55,.5,.45,.5)     infinite;
}
.parallax > use:nth-child(1) {
  animation-delay: -2s;
  animation-duration: 7s;
}
.parallax > use:nth-child(2) {
  animation-delay: -3s;
  animation-duration: 10s;
}
.parallax > use:nth-child(3) {
  animation-delay: -4s;
  animation-duration: 13s;
}
.parallax > use:nth-child(4) {
  animation-delay: -5s;
  animation-duration: 20s;
}
@keyframes move-forever {
  0% {
   transform: translate3d(-90px,0,0);
  }
  100% { 
    transform: translate3d(85px,0,0);
  }
}
/*Shrinking for mobile*/
@media (max-width: 768px) {
  .waves {
    height:40px;
    min-height:40px;
  }
}
</style>